import React, { Component, useState, useEffect } from 'react';
import  './styles.css'
import { Container, Row,  } from "reactstrap";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

const about = [{
        Heading: "Vajramudita (Vee) Armstrong",
        SubHeading: "",
        Context: 
            <div>
                <p>Vee has worked as a leader in Astrazeneca and the third sector, and has 28 years’ experience as Director, Manager and Engineer. She has created and led teams of 100 people with experience of leading global and virtual teams throughout her career.</p>

                <p>She has run many leadership development programmes, facilitated team development events, and has a passion for creating engagement and collaboration in organisations through Open Space, and World Cafe events. She is also a qualified mindfulness trainer and facilitates Thrive, well-being programmes for teams and organisations.</p>

                <p>Accredited as a Leadership Coach, Vee has a special interest in working with Leaders facing transitions, complexity and particularly stressful challenges. She helps both Leaders and their organisations to remember their humanity, as a result of which clients go away more confident, resilient, engaged and impactful.</p>

                <p>Vee’s coaching experience goes back to 2006. Vee has a Level 7 ILM Diploma in Executive Coaching and Leadership Mentoring; Mindfulness training accreditation from Breathworks CIC; and is qualified to use a wide range of psychometric tools for individuals and teams. She has a BSc in Control Electrical Engineering from Durham University.</p>
            </div>,
        img: "/images/photos/Vee400.jpg"
    },
    {
        Heading: "Mokshajyoti (MJ) Stephens",
        SubHeading: "",
        Context: 
            <div>
                <p>MJ is a highly experienced and highly sought after programme facilitator and mindfulness trainer. As an accredited senior mindfulness trainer with Breathworks he has taught many courses to help people with both chronic health conditions and those suffering from stress and anxiety.</p>

                <p>He has had a personal practice of mindfulness of more than 25 years and is also a qualified Alexander Technique teacher, with a particular interest in movement.</p>

                <p>MJ has a broad range of workplace experience, much of it within the NHS, including Stress courses for staff, tasters for Graduate Managers, a three day programme with Macmillan cancer HP, Physiotherapists at Sussex Community NHS, Teacher Training at Sheffield IAPT, Manchester University, Liverpool School of Tropical Medicine, Maggie’s Cancer charity, Cheshire Fire and Rescue, RCM Manchester and other local businesses in Manchester.
                He is a member of BAMBA.</p>
            </div>,
        img: "/images/photos/Mj400.jpg"
    },
    {
        Heading: "Eliot (Avi) Franks",
        SubHeading: "",
        Context: <div>
            <p>MSc CPsychol MISCP Avi has over 25 years’ experience in the fields of psychological assessment, leadership development, executive coaching, organisational consultancy and conference speaking. He began his career as a consultant within the Saatchi and Saatchi Group before qualifying as a chartered psychologist with particular interests in psychological resilience and organisational leadership. Since then he has worked for several government agencies, as well as commercial consultancies, supporting senior executives and their teams achieve their potential. For several years, Avi was a full-time coach to some of the UK’s most senior police personnel and twice served as the executive coach on the police service’s four months (international) Strategic Command Course. </p>
                
            <p>He also has significant experience of designing development centres, leadership (and positive action) programmes, and team facilitation. As a coaching psychologist, Avi draws on evidence-based theory and practice, He emphasises the development of self-awareness as a prerequisite for effective, ethical and resilient leadership. He takes a pragmatic and sustainable approach, supporting clients to clarify and then achieve their objectives within the broader context of their lives. Outside of work Avi devotes his time to men’s wellbeing initiatives and Buddhist activities in the UK and abroad. For several years he chaired the Manchester Buddhist Centre (charity) and sat on the executive of The European (Buddhist) Chairs Assembly. He is currently the president a Buddhist charity in New Zealand. Avi is a member of the British Psychological Society (BPS), the BPS Special Group in Coaching Psychology, and the International Society for Coaching Psychology.</p>
        </div>,
        img: "/images/photos/Avi400.webp",
}]

const TextCol = ({Heading, Context, SubHeading, i, img}) => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
        setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (i%2 === 0 && windowDimensions.width>768){
        return (
            <Row className='content'>
                <div className='About-Section'>
                    <h4>
                        {Heading}
                    </h4>
                    <h6 className="subHeading">
                        {SubHeading}
                    </h6>
                    {Context}
                </div>
                <img src={img} className="People" alt={Heading}/>
            </Row>
            )
        }
    else{
        return (
            <Row className='content'>
                <img src={img} className="People" alt={Heading}/>
                <div className='About-Section'>
                    <h4>
                        {Heading}
                    </h4>
                    <h6 className="subHeading">
                        {SubHeading}
                    </h6>
                    {Context}
                </div>
            </Row>)
        }
    }

class About extends Component {
    render() {
        return ( <div>
            <Container>
                <Row>
                    <h2 className='Title'>
                        Meet the team
                    </h2>
                </Row>
                {about.map((col, i) => (
                    <TextCol Heading={col.Heading} Context={col.Context} SubHeading={col.SubHeading} i={i + 1} img={col.img} key={col.Heading}/>
                ))}
            </Container>
        </div> );
    }
}
 
export default About;